import { render, staticRenderFns } from "./RiskCompliance.vue?vue&type=template&id=159cea42&scoped=true&"
import script from "./RiskCompliance.vue?vue&type=script&lang=js&"
export * from "./RiskCompliance.vue?vue&type=script&lang=js&"
import style0 from "./RiskCompliance.vue?vue&type=style&index=0&id=159cea42&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "159cea42",
  null
  
)

export default component.exports